module.exports = __webpack_public_path__ + "8bc5349ae916afd445761bb41d5b93c5.pdf";